<template>
  <v-dialog
    v-model="show"
    width="640"
  >
    <v-card
      class="dialogBackground"
      :disabled="loading"
    >
      <v-row
        no-gutters
        class="dialogTitleBackground white--text px-2 py-1 mb-2"
        align="center"
      >
        <span> {{ readOnly ? 'Просмотр' : good.id > 0 ? 'Изменение' : 'Добавление' }} товара </span>
        <v-spacer></v-spacer>
        <v-btn
          small
          icon
          dark
          @click="cancelClick"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-card-text>
        <v-row
          align="center"
          justify="center"
          no-gutters
          class="mx-0"
        >
          <v-col cols="6  pl-0 pr-1">
            <CargoTypeSelector
              v-model="good.cargoTypeID"
              :canAny="false"
              :disabled="good.id > 0"
              :error-messages="objectErrors(this.$v.good.cargoTypeID)"
            ></CargoTypeSelector>
          </v-col>

          <v-col cols="6 pr-0 pl-1">
            <v-text-field
              autocomplete="off"
              type="text"
              label="Артикул"
              v-model="good.article"
              :error-messages="objectErrors(this.$v.good.article)"
              :counter="this.$v.good.article.$params.maxLength.max"
              @input="$v.good.article.$touch()"
              @blur="$v.good.article.$touch()"
              :readonly="good.id > 0 || readOnly"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              autocomplete="off"
              type="text"
              label="Наименование"
              v-model="good.name"
              :error-messages="objectErrors(this.$v.good.name)"
              :counter="this.$v.good.name.$params.maxLength.max"
              @input="$v.good.name.$touch()"
              @blur="$v.good.name.$touch()"
              :readonly="readOnly"
            ></v-text-field>
          </v-col>

          <v-col cols="6 pl-0 pr-1">
            <v-text-field
              autocomplete="off"
              type="text"
              label="Штук в упаковке"
              v-model="good.qiPackage"
              :error-messages="objectErrors(this.$v.good.qiPackage)"
              @input="$v.good.qiPackage.$touch()"
              @blur="$v.good.qiPackage.$touch()"
              :readonly="readOnly"
            ></v-text-field>
          </v-col>

          <v-col cols="6 pr-0 pl-1">
            <v-text-field
              autocomplete="off"
              type="text"
              label="Штук на поддоне"
              v-model="good.qiPallet"
              :error-messages="objectErrors(this.$v.good.qiPallet)"
              @input="$v.good.qiPallet.$touch()"
              @blur="$v.good.qiPallet.$touch()"
              :readonly="readOnly"
            ></v-text-field>
          </v-col>

          <v-col cols="6 pl-0 pr-1">
            <v-text-field
              autocomplete="off"
              type="text"
              label="Вес 1 штуки, кг"
              v-model="good.weight"
              :error-messages="objectErrors(this.$v.good.weight)"
              @input="$v.good.weight.$touch()"
              @blur="$v.good.weight.$touch()"
              :readonly="readOnly"
            ></v-text-field>
          </v-col>

          <v-col cols="6 pr-0 pl-1">
            <v-text-field
              autocomplete="off"
              type="text"
              label="Цена за 1 упаковку, руб"
              v-model="good.price"
              :error-messages="objectErrors(this.$v.good.price)"
              @input="$v.good.price.$touch()"
              @blur="$v.good.price.$touch()"
              :readonly="readOnly"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-8">
        <v-spacer></v-spacer>
        <v-btn
          v-if="!readOnly"
          class="px-6"
          outlined
          @click.prevent="cancelClick"
        >Отмена</v-btn>
        <v-btn
          v-if="!readOnly"
          class="px-4"
          color="primary"
          @click.prevent="okClick"
          :loading="loading"
        >
          Сохранить
        </v-btn>
        <v-btn
          v-else
          class="px-6"
          color="primary"
          @click.prevent="cancelClick"
          :loading="loading"
        >Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CargoTypeSelector from '@/components/CargoTypeSelector'
import { required, minLength, maxLength, minValue, maxValue, integer, decimal } from 'vuelidate/lib/validators'

export default {
  props: {
    value: Object, // показать диалог если есть открываемый элемент
    saveCallback: Function,
    readOnly: Boolean
  },

  data: () => ({
    good: {},
    loading: false
  }),

  watch: {
    value (val) {
      this.good = {
        ...val,
        // если товар есть, но это пустой объект, то дать ему id = -1, если null, то 0 иначе id
        id: val?.id ? val.id : val ? -1 : 0
      }
    }
  },

  computed: {
    show: {
      get () {
        // показываем если id != 0
        return this.good.id
      },
      set (val) {
        this.$v.$reset()
        if (!val) {
          // сбрасываем объект, который передавали в диалог
          this.$emit('input', null)
        }
      }
    }
  },

  validations () {
    return {
      good: {
        cargoTypeID: { required },
        name: { required, minLength: minLength(4), maxLength: maxLength(250) },
        article: { required, minLength: minLength(2), maxLength: maxLength(20) },
        qiPackage: { required, integer, minValue: minValue(1) },
        qiPallet: { required, integer, minValue: minValue(1) },
        price: { required, decimal, minValue: minValue(0.01), maxValue: maxValue(1000000) },
        weight: { required, decimal, minValue: minValue(0.001), maxValue: maxValue(100) }
      }
    }
  },

  methods: {
    objectErrors (obj) {
      if (!obj.$dirty) return []
      const errors = []

      obj.$params.integer && !obj.integer && errors.push('Введите целое число')
      obj.$params.decimal && !obj.decimal && errors.push('Введите число')

      obj.$params.minValue && !obj.minValue && errors.push(`Значение должно быть больше ${obj.$params.minValue.min}`)
      obj.$params.maxValue && !obj.maxValue && errors.push('Слишком большое значение')

      obj.$params.maxLength &&
        !obj.maxLength &&
        errors.push(`Не более ${obj.$params.maxLength.max} символов, пожалуйста`)

      obj.$params.minLength &&
        !obj.minLength &&
        errors.push(`Не менее ${obj.$params.minLength.min} символов, пожалуйста`)

      obj.$params.required && !obj.required && errors.push('Введите значение')
      return errors
    },

    async okClick () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.loading = true
      const res = await this.saveCallback(this.good)
      if (res) {
        this.show = false
      }
      this.loading = false
    },

    cancelClick () {
      this.show = false
    }
  },

  components: {
    CargoTypeSelector
  }
}
</script>
